import Box from '@mui/material/Box';

// ----------------------------------------------------------------------

// Custom sparkle mark for Report Insights: one large outlined star with two small solid stars
// at the top-right. Drawn with currentColor so it follows the surrounding text color.
export function ReportInsightsIcon({ size = 24, sx = {} }) {
  return (
    <Box
      component="svg"
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden
      sx={{ width: size, height: size, flexShrink: 0, display: 'inline-block', ...sx }}
    >
      <path
        d="M10 6.5c.6 4.1 3.4 6.9 7.5 7.5-4.1.6-6.9 3.4-7.5 7.5-.6-4.1-3.4-6.9-7.5-7.5 4.1-.6 6.9-3.4 7.5-7.5Z"
        stroke="currentColor"
        strokeWidth={1.6}
        strokeLinejoin="round"
      />
      <path
        d="M16.2 2.2c0.32 2.19 1.81 3.68 4 4-2.19 0.32-3.68 1.81-4 4-0.32-2.19-1.81-3.68-4-4 2.19-0.32 3.68-1.81 4-4Z"
        fill="currentColor"
      />
      <path
        d="M20.2 15.9c0.12 0.82 0.68 1.38 1.5 1.5-0.82 0.12-1.38 0.68-1.5 1.5-0.12-0.82-0.68-1.38-1.5-1.5 0.82-0.12 1.38-0.68 1.5-1.5Z"
        fill="currentColor"
      />
    </Box>
  );
}
